import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronDown,
  faChevronUp,
  faPenToSquare,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import type { Competency } from '../../types/GrowthWheelManagement'
import { getLevelCompletionStatus } from './wheelManagementUtils'
import { RichTextView } from './RichTextView'

type Props = {
  competency: Competency
  compIndex: number
  areaCompetenciesLength: number
  onMove: (direction: 'up' | 'down') => void
  onEdit: () => void
  onDeleteClick: () => void
}

export function SubCompetencyRow({
  competency,
  compIndex,
  areaCompetenciesLength,
  onMove,
  onEdit,
  onDeleteClick,
}: Props) {
  const levelStatus = getLevelCompletionStatus(competency)
  const isComplete = levelStatus.defined === levelStatus.total

  return (
    <div className="gw-wm__sub-row">
      <div className="gw-wm__sub-row-main">
        <div className="gw-wm__sub-row-text">
          <div className="gw-wm__sub-row-title">
            <h4 className="gw-wm__sub-name">{competency.name}</h4>
            <span
              className={`gw-wm__badge ${
                isComplete ? 'gw-wm__badge--ok' : 'gw-wm__badge--warn'
              }`}
            >
              {levelStatus.defined}/{levelStatus.total} rubric levels defined
            </span>
          </div>
          <RichTextView
            className="gw-wm__sub-desc"
            html={competency.description}
            fallback={
              <p className="gw-wm__sub-desc gw-wm__desc-placeholder">
                No description yet.
              </p>
            }
          />
        </div>
      </div>
      <div className="gw-wm__area-actions">
        <div className="gw-wm__reorder">
          <button
            type="button"
            className="gw-wm__btn-icon"
            disabled={compIndex === 0}
            title="Move up"
            onClick={() => onMove('up')}
          >
            <FontAwesomeIcon icon={faChevronUp} size="sm" />
          </button>
          <button
            type="button"
            className="gw-wm__btn-icon"
            disabled={compIndex === areaCompetenciesLength - 1}
            title="Move down"
            onClick={() => onMove('down')}
          >
            <FontAwesomeIcon icon={faChevronDown} size="sm" />
          </button>
        </div>
        <button
          type="button"
          className="gw-wm__btn-icon"
          title="Edit sub-competency"
          onClick={onEdit}
        >
          <FontAwesomeIcon icon={faPenToSquare} size="sm" />
        </button>
        <button
          type="button"
          className="gw-wm__btn-icon gw-wm__btn-icon--danger"
          title="Delete sub-competency"
          onClick={onDeleteClick}
        >
          <FontAwesomeIcon icon={faTrash} size="sm" />
        </button>
      </div>
    </div>
  )
}
